import { z } from 'zod';
import {
  DOB_SCHEMA,
  SSN_SCHEMA,
} from 'typescript/schemas/finance_forms/common';
import { CountryCode } from 'typescript/constants/localization';

/**
 * generates the schema for the finance fields
 * @returns finance fields schema to be used in the zodResolver in react-hook-form
 */
export const createFinanceFieldsSchema = ({
  countryCode,
}: {
  countryCode: CountryCode;
}): z.ZodObject<any> => {
  const financeFieldsSchema = {
    [`personal_birthdate`]: DOB_SCHEMA,
  };

  if (countryCode === CountryCode.US) {
    financeFieldsSchema[`personal_ssn`] = SSN_SCHEMA;
  }

  return z.object(financeFieldsSchema);
};
